import Badge from '@/components/badges/Badge'
import RenderIf from '@/components/ui/render-if'
import { Text } from '@/components/ui/text'
import { WalletInfo } from '@/config'
import { cn } from '@/lib'
import { isMobileDevice } from '@/utils'

export const WalletItem = ({
  wallet,
  onClick,
  isSupported,
  isConnected,
  isRecent,
  isSelected,
  className,
}: {
  wallet: WalletInfo
  onClick: () => void
  isSupported: boolean
  isConnected: boolean
  isRecent: boolean
  isSelected: boolean
  className: string
}) => {
  if (!isSupported) return null
  return (
    <button
      onClick={isSupported ? onClick : undefined}
      className={cn(
        'flex w-full items-center space-x-2 rounded-sm p-2 duration-300 justify-between text-size-16',
        isSelected
          ? 'bg-white-8'
          : isSupported
            ? 'hover:bg-white-12 hover:text-white text-white-48'
            : 'cursor-not-allowed border-surface-stroke bg-transparent text-white-48 opacity-50',
        className
      )}
      disabled={!isSupported}
    >
      <div className='flex gap-2 items-center'>
        <img src={wallet.icon} alt={wallet.name} className='size-8 rounded-lg' />
        {wallet.name}
      </div>
      <RenderIf condition={!isMobileDevice()}>
        {isConnected ? (
          <Badge
            status={'success'}
            text={
              <Text color='green' size={12}>
                Connected
              </Text>
            }
          />
        ) : isRecent ? (
          <Badge
            status={'waiting'}
            text={
              <Text color='main' size={12}>
                Recent
              </Text>
            }
          />
        ) : wallet.isDetected() ? (
          <Text color='white-48' size={12}>
            Detected
          </Text>
        ) : null}
      </RenderIf>
    </button>
  )
}
